import { Dispatch, ReactNode, SetStateAction, useState } from 'react'
import { DragDropContext, OnDragEndResponder } from 'react-beautiful-dnd'

import { AssociationsModal } from 'src/components'
import { AssociationsType, IFormSelectedImpacts } from 'src/types'

import useStyles from './styles'
import { AssociationList } from './associations-list.component'

export interface ISelectedIconWithActions {
  icon: string
  text: string
  id: string
  subText?: string
  home_page_show: boolean
  impact_page_show: boolean
  journey_page_show?: boolean
}

export interface IAccountSelectedIcon {
  icon: string
  text: string
  id: string
  subText?: string
  aiGenerated?: boolean
}

export interface IAction {
  lable: ReactNode
  isShow: (id: string) => boolean
  handleSwitch: (id: string) => void
}

interface Props {
  type: AssociationsType
  description: string | ReactNode
  modalTitle?: string
  selectedItems: IFormSelectedImpacts[]
  setSelectedItems: (value: IFormSelectedImpacts[]) => void
  handleSelectItem: (value: IFormSelectedImpacts) => void
  selectedIcons?: IAccountSelectedIcon[] | null
  isRound?: boolean
  withDnd?: boolean
  modalContentNode?: ReactNode
  disabled?: boolean
  disabledItemLink?: boolean
  actions?: IAction[]
  actionsTitle?: ReactNode
}

const AssociationsWithActions = ({
  disabled,
  type,
  description,
  isRound,
  selectedItems,
  setSelectedItems,
  handleSelectItem,
  selectedIcons,
  withDnd,
  modalContentNode,
  disabledItemLink,
  actions,
  actionsTitle,
}: Props) => {
  const classes = useStyles({ isRoundImage: isRound })
  const [open, setOpen] = useState(false)

  const handleOpenModal = () => {
    setOpen(true)
  }

  const handleCloseModal = () => {
    setOpen(false)
  }

  const handleDragEnd: OnDragEndResponder = ({ draggableId, source, destination }) => {
    if (!destination) return

    if (destination.droppableId === source.droppableId && destination.index === source.index) return

    if (!selectedItems) return
    const newselectedItems = [...selectedItems]

    const draggableItem = selectedItems.filter((item) => item.id === draggableId)[0]

    newselectedItems.splice(source.index, 1)
    newselectedItems.splice(destination.index, 0, draggableItem)
    setSelectedItems(newselectedItems)
  }

  const selectionCount = selectedItems ? selectedItems.length : 0

  return (
    <div className={classes.bigContainer}>
      <div className={classes.text}>{description}</div>
      <div className={classes.textCounter}>
        {selectionCount} {type}
      </div>
      <DragDropContext onDragEnd={handleDragEnd}>
        <AssociationList
          selectedItems={selectedItems}
          disableItemLink={disabledItemLink}
          disabled={disabled}
          withDnd={!!withDnd}
          selectedIcons={selectedIcons}
          type={type}
          actions={actions}
          actionsTitle={actionsTitle}
        />
      </DragDropContext>
      <AssociationsModal
        type={type}
        open={open}
        isImageRound={isRound}
        selectedItemsWithAction={selectedItems}
        handleCloseModal={handleCloseModal}
        handleSelectItemWithAction={handleSelectItem}
        modalContentNode={modalContentNode}
      />
      <input
        width={'100%'}
        name="image"
        accept="image/*"
        id={`id-${type}`}
        type="checkbox"
        multiple
        hidden
        onChange={handleOpenModal}
      />
    </div>
  )
}

export { AssociationsWithActions }
